import * as tslib_1 from "tslib";
import { View } from './view';
var Breakpoint = /** @class */ (function (_super) {
    tslib_1.__extends(Breakpoint, _super);
    function Breakpoint() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.matchers = new Map();
        _this.onInit = _this.createMatchers;
        _this.onBeforeUpdate = _this.createMatchers;
        _this.onRemove = _this.removeMatchers;
        return _this;
    }
    Breakpoint.prototype.createMatchers = function () {
        var _this = this;
        var _a = this.attrs, children = _a.children, breakpoints = tslib_1.__rest(_a, ["children"]);
        var keys = Object.keys(breakpoints);
        keys.forEach(function (query) {
            if (_this.matchers.has(query))
                return;
            var matcher = matchMedia(query);
            matcher.addListener(_this.redraw);
            _this.matchers.set(query, matchMedia(query));
        });
        this.removeMatchers(keys);
    };
    Breakpoint.prototype.removeMatchers = function (except) {
        var _this = this;
        if (except === void 0) { except = []; }
        this.matchers.forEach(function (matcher, query) {
            if (except.indexOf(query) > -1)
                return;
            matcher.removeListener(_this.redraw);
            _this.matchers.delete(query);
        });
    };
    Breakpoint.prototype.render = function () {
        var _a = this.attrs, children = _a.children, breakpoints = tslib_1.__rest(_a, ["children"]);
        var keys = Object.keys(breakpoints);
        var active = Array.from(this.matchers).reduce(function (active, _a) {
            var key = _a[0], matcher = _a[1];
            if (!matcher.matches)
                return active;
            if (!active)
                return key;
            if (keys.indexOf(key) > keys.indexOf(active))
                return key;
            return active;
        }, null);
        return active && children && children(this.attrs[active]);
    };
    return Breakpoint;
}(View));
export { Breakpoint };
